import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
class TopBar extends React.Component {

    render() {
        return (
            <div>
                <div className="main-top-bar" style={this.props.style}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export { TopBar };
